define('components/factory/models/VideoModel', [

], function() {

    var VideoModel = Backbone.Model.extend({
        defaults: {
            viewId: "video-id",             // Classic default viewId
            video: {},                      // Video object
                                            // -> type ( "youtube" || "mmm" || "html" )
                                            // -> videoId for youtube & mmm
                                            // -> videoFile for html
                                            // -> Find more details in videofactory
            videoClassRatio: "16-9",        // Video ratio ( "16-9" || "4-3" )
            onReady: null,                  // Callback when video is ready
            onProgress: null,               // Callback on video progress
            onPlay: null,                   // Callback when video play
            onPause: null,                  // Callback when video is paused
            onEnded: null,                  // Callback when video finished
            onFullscreenChange: null,       // Callback when fullscreen state change
            isReady: false                  // Classic isReady
        }
    });

    return VideoModel;
});
